
import { useParams } from "react-router";
import useFetchTiming from "../listing/hooks/useFetchTiming";

const useFetchEmojis = () => {
    const { timing:timingSlug } = useParams();
    const timing = useFetchTiming(timingSlug);
    return timing?.data?.emojis?.length > 0 ? timing.data.emojis :  ['👏','👋','😄','😭','😂','❤️','🎉'];
}

export default useFetchEmojis;
